module.exports = __webpack_public_path__ + "static/img/图层 589.c0dc0799.png";